import { useNavigate } from 'react-router-dom';

import { ColorButton } from '../../UI';

import { getLogo, truncateString } from '../../../helpers/functions';

import { IStrategy, IAsset } from '../../../types/model';

export const SearchItem = ({
  item,
  value = '',
  onClick,
}: {
  item: IStrategy | IAsset;
  value?: string;
  onClick(): void;
}) => {
  const navigate = useNavigate();

  const isStrategy = item.__typename === 'Strategy';
  const src =
    !isStrategy && 'type' in item ? getLogo(item.type, item.logo) : '';

  const handleClick = () => {
    onClick();
    navigate(
      !isStrategy && 'type' in item
        ? `/market/${item.id}/${item.type}/withoutFilter/overview`
        : `/strategies/${item.id}`
    );
  };

  return (
    <div className="group p-2 my-2 cursor-pointer hover:bg-primary hover:text-black rounded-lg">
      <div
        className="flex items-center w-full"
        key={item.id}
        onClick={handleClick}
      >
        {isStrategy && 'color' in item ? (
          <ColorButton radius={3} color={item.color} isReadOnly={true} />
        ) : (
          <div className="flex justify-center items-center w-7 h-7 bg-black rounded-full overflow-hidden">
            <img
              className="object-scale-down h-7 w-full"
              alt={item.name}
              src={src}
            />
          </div>
        )}

        <div className="flex flex-col mr-auto text-sm mx-2">
          <div className="font-medium capitalize-first">
            {!isStrategy && 'symbol' in item
              ? item.symbol.toUpperCase()
              : item.name}
          </div>
          <div className="text-sm text-grey-30 group-hover:text-black capitalize-first">
            {!isStrategy && 'type' in item
              ? truncateString(item.name, 20) +
                (item.exchange ? ' (' + item.exchange + ')' : '')
              : item.__typename}
          </div>
        </div>
      </div>
    </div>
  );
};
